module.exports = __webpack_public_path__ + "img/skip-button.d40cbaf9.png";